"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    isCustomArrow?: boolean;
    tooltipArrowClassName?: {
      container?: string;
      arrow?: string;
    };
  }
>(({ className, sideOffset = 4, isCustomArrow = false, tooltipArrowClassName, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "bg-tooltip text-tooltip-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md px-2 py-2.5 text-xs shadow-md",
        className,
      )}
      {...props}
    >
      {isCustomArrow ? (
        <span className={tooltipArrowClassName?.container}>
          <svg
            className="fill-tooltip transition-opacity duration-200 ease-in-out data-[state=closed]:opacity-0 data-[state=open]:opacity-100"
            width="10"
            height="5"
            viewBox="0 0 30 10"
            preserveAspectRatio="none"
          >
            <polygon points="0,0 30,0 15,10"></polygon>
          </svg>
        </span>
      ) : (
        <TooltipPrimitive.Arrow
          className={cn(
            "fill-tooltip transition-opacity duration-200 ease-in-out",
            "data-[state=closed]:opacity-0 data-[state=open]:opacity-100",
            tooltipArrowClassName?.arrow,
          )}
        />
      )}
      {props.children}
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
